import { NgModule } from '@angular/core';
import { DatePipe, CommonModule } from '@angular/common';
import { MaterialModule } from "../material.module";
import { DataTableComponent } from "./data-table/data-table.component";
import { FormTemplateComponent } from "./form-template/form-template.component";
import { TimeDifferencePipe } from './pipes/time-difference.pipe';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { CommonDialogComponent } from './common-dialog/common-dialog.component';
import { AgePipe } from './pipes/age.pipe';
import { ManualRefreshComponent } from './manual-refresh/manual-refresh.component';
import { ManualRefreshService } from "../services/manual-refresh/manual-refresh.service";
import { CvaAuthPermCheckDirective } from './directives/cva-auth-perm-check/cva-auth-perm-check.directive';
import { TrimTextDirective } from './directives/trim-text/trim-text.directive';
import { ToTitleCasePipe } from './pipes/to-title-case.pipe';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { SideNavUserMenuItemsComponent } from '../components/side-nav-user-menu-items/side-nav-user-menu-items.component';
import { GenerateButtonComponent } from './generate-button/generate-button.component';
import { ReferralDialogComponent } from './referral-dialog/referral-dialog.component';
import { RtfEditorComponent } from './rtf/rtf-editor/rtf-editor.component';
import { RtfEditorService } from './rtf/rtf-editor/rtf-editor.service';
import { LucideAngularModule } from 'lucide-angular';
import { NgxTiptapModule } from 'ngx-tiptap';
import { FormsModule } from '@angular/forms';
import { TemplateListingComponent } from '../components/manage-template/template-listing/template-listing.component';

@NgModule({
  declarations: [
    DataTableComponent,
    FormTemplateComponent,
    TimeDifferencePipe,
    ConfirmationDialogComponent,
    SideNavUserMenuItemsComponent,
    CommonDialogComponent,
    AgePipe,
    ManualRefreshComponent,
    CvaAuthPermCheckDirective,
    TrimTextDirective,
    ToTitleCasePipe,
    GenerateButtonComponent,
    ReferralDialogComponent,
    RtfEditorComponent
  ],
  imports: [MaterialModule, CommonModule, NgbPopoverModule, LucideAngularModule, NgxTiptapModule, FormsModule, TemplateListingComponent],
  providers: [
    DatePipe,
    TimeDifferencePipe,
    AgePipe,
    ManualRefreshService,
    RtfEditorService
  ],
  exports: [
    DataTableComponent,
    FormTemplateComponent,
    MaterialModule,
    DatePipe,
    TimeDifferencePipe,
    CommonDialogComponent,
    ConfirmationDialogComponent,
    SideNavUserMenuItemsComponent,
    AgePipe,
    ManualRefreshComponent,
    CvaAuthPermCheckDirective,
    TrimTextDirective,
    GenerateButtonComponent,
    ReferralDialogComponent,
    RtfEditorComponent
  ]
})
export class SharedModule { }
